export default __webpack_public_path__ + "static/media/dgt_paper.14698874.png";